"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculationDetailSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
exports.calculationDetailSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    anyOf: [
        {
            required: [
                'documentID',
                'documentCreatedID',
                'documentTypeCode',
                'fileByteCount',
                'fileName',
                'submitterUserID',
                'submitterUserTypeCode',
            ],
        },
        {
            required: ['documentCreatedID', 'submitterUserID', 'submitterUserTypeCode'],
        },
    ],
    properties: {
        documentID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        documentTypeCode: {
            type: 'string',
            enum: Object.values(constants_2.ClaimDocumentType),
            errorMessage: 'Should equate to a valid ClaimDocumentType Enum value or null',
        },
        fileName: {
            type: 'string',
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        fileByteCount: {
            type: 'number',
            errorMessage: 'file byte count should be numberic only',
        },
        documentCreatedID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        submitterUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        submitterUserTypeCode: {
            type: 'number',
            enum: Object.values(constants_1.UserType),
            errorMessage: 'Should equate to a valid UserType Enum value',
        },
        uploadStatusCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(constants_1.Status), [null]),
            errorMessage: 'Should equate to a valid Status Enum value or null',
        },
    },
};
